import TemplateView from '../../TemplateView'
import LeaveBalanceEditor from './LeaveBalanceEditor'
import messageResource from '../../messageResource'

export default class LeaveBalanceEditorContent extends TemplateView {
    templateHtml() {
        return "<div id='leaveBalanceEditor' class='daysMode'>" +
               "    <div class='title'></div>" +
               "    <table>" +
               "        <tr>" +
               "            <td class='correctionTypeSwitcherCell'>" +
               "                <button class='correctionTypeButton'></button>" +
               "            </td>" +
               "            <td class='valuesCell'>" +
               "                <div>" +
               "                    <span class='inHardValueMode'>" +
               "                        <input class='hardValueField' type='text'>" +
               "                        <span class='inDaysMode'><%=unitsDaysShort%></span>" +
               "                        <span class='inHoursMode'><%=unitsHoursShort%></span>" +
               "                    </span>" +
               "                    <span class='inIncreaseValueMode inDecreaseValueMode'>" +
               "                        <span class='inDaysMode'><span class='baseValue'>#</span> <%=unitsDaysShort%></span>" +
               "                        <span class='inHoursMode'><span class='baseValue'>#</span> <%=unitsHoursShort%></span>" +
               "                        <span class='inIncreaseValueMode'>+</span>" +
               "                        <span class='inDecreaseValueMode'>&minus;</span>" +
               "                        <input class='relativeValueField' type='text'>" +
               "                        <span class='inDaysMode'><%=unitsDaysShort%></span>" +
               "                        <span class='inHoursMode'><%=unitsHoursShort%></span>" +
               "                    </span>" +
               "                </div>" +
               "                <div class='unitsSwitcher'>" +
               "                    <button class='daysButton'><%=unitsDays%></button> " +
               "                    <div class='separator'></div>" +
               "                    <button class='hoursButton'><%=unitsHours%></button>" +
               "                </div>" +
               "            </td>" +
               "            <td class='applyButtonCell'>" +
               "                <button class='applyButton'>" +
               "                    <span class='defaultText'><%=applyButtonDefaultText%></span>" +
               "                    <span class='savingText'><%=applyButtonSavingText%></span>" +
               "                </button>" +
               "            </td>" +
               "        </tr>" +
               "        <tr class='errorMessageRow'>" +
               "            <td></td>" +
               "            <td colspan='2'>" +
               "                <table>" +
               "                    <tr>" +
               "                        <td class='errorIconCell'>" +
               "                            <div class='iconImg'></div>" +
               "                        </td>" +
               "                        <td class='errorTextCell'>#</td>" +
               "                    </tr>" +
               "                </table>" +
               "            </td>\n" +
               "        </tr>" +
               "        <tr>" +
               "            <td colspan='3'>" +
               "                <textarea class='comments' placeholder='<%=addComments%>'></textarea>" +
               "            </td>" +
               "        </tr>" +
               "    </table>" +
               "</div>"
    }

    messageKeys() {
        return {
            unitsDaysShort: 'common.pto_units.days.short',
            unitsHoursShort: 'common.pto_units.hours.short',
            unitsDays: 'common.pto_units.days',
            unitsHours: 'common.pto_units.hours',
            applyButtonDefaultText: 'common.apply',
            applyButtonSavingText: 'common.saving.ellipsis',
            addComments: 'common.add_comments',
        }
    }

    afterRender() {
        this.leaveBalanceEditorActions = new LeaveBalanceEditor(this.$el)
    }

    show(element, baseValueInDays, userName, ptoHoursPerDay, balanceType, titleMessageKey) {
        this.find(".title").text(messageResource.getMessage(titleMessageKey))
        this.leaveBalanceEditorActions.show(element, baseValueInDays, userName, ptoHoursPerDay, balanceType)
    }

    setOnCloseCallback(callback) {
        this.leaveBalanceEditorActions.setOnCloseCallback(callback)
    }

    setOnApplyCallback(callback) {
        this.leaveBalanceEditorActions.setOnApplyCallback(callback)
    }

    busyModeOff() {
        this.leaveBalanceEditorActions.busyModeOff()
    }

    hide() {
        this.leaveBalanceEditorActions.hide()
    }

    showCapExceededError(capInDays) {
        this.leaveBalanceEditorActions.showCapExceededError(capInDays)
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/LeaveBalanceEditorContent.js